import React from 'react'
import CarouselContent from 'components/inputs/Material/CarouselContent/index'
import FooterButtons from 'components/inputs/Material/FooterButtons/index'
import Info from 'components/inputs/Material/Info/index'
import { FormFieldsContainer } from '../Shared/styles'

export default function Carousel() {
  return (
    <>
      <FormFieldsContainer>
        <Info />
        <CarouselContent />
      </FormFieldsContainer>
      <FooterButtons />
    </>
  )
}
